import { BaseSelectHTMLHTMLElement } from "components/input/select/baseSelectHTMLElement";
import { Tooltip } from "components/components/tooltip/tooltip";
import { Optgroup, Option } from "components/input/select/options";
import { OptionIterator } from "components/input/select/OptionIterator";
import $ from "jquery";
import template from "components/input/select/selectElement.hbs";
import optionsTemplate from "components/input/select/options.hbs";

export class SelectMultipleInputElement extends BaseSelectHTMLHTMLElement {

    constructor() {
        super();

        this.codeInOptionLabel = (this.getAttribute("codeInOptionLabel") === "true");

        const optTemplate = {
            "multiple": true,
            "prefixId": "msi",
            "id": this.getAttribute("_id"),
            "className": "c-selectmultiple-input__input o-form-component__input o-form-component__input-group__input",
            "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
            "style": this.getAttribute("_style"),
        } as any;

        this.innerHTML = template(optTemplate);

        this.input = this.querySelector("select");

        this.bindEvents();
        Tooltip.bindElement(this);
    }

    public set data(v: string[]) {
        $(this.input).val(v.map(String));
        this.initialValue.value = this.data;
    }

    public get data(): string[] {
        if (this.options == null || this.options.length === 0) {
            return null;
        }

        const idxes = [...this.input.selectedOptions].map((opt) => opt.index);
        let allOptions = OptionIterator.filterFlat(
            this.options,
            () => true);
        if (idxes != null && idxes.length > 0) {
            let selectedOptions: string[] = [];
            idxes.forEach(idx => {
                selectedOptions.push(allOptions[idx].value?.toString() ?? null);
            });
            return selectedOptions;
        }
        return null;
    }

    public addOptions(options: Array<Option | Optgroup>): void {
        if (options == null) {
            return;
        }
        if (this.options == null) {
            this.options = [];
        }
        this.options = this.options.concat(options);
        let templated = $(optionsTemplate({ options, codeInOptionLabel: this.codeInOptionLabel }));
        templated.appendTo(this.input as JQuery<HTMLElement>);

        if (!this.input.disabled) {
            this.bindEventDblclickOptions();
        }
    }

    private bindEventDblclickOptions() {
        //Opcion para deseleccionar valores de options cndo solo queda una
        let options = this.input.querySelectorAll("option") as HTMLOptionElement[];
        options.forEach(opt => {
            opt.addEventListener("dblclick", (evt) => {
                const option = (evt.target) as HTMLOptionElement;
                if (option.selected && (!(option.parentElement as HTMLSelectElement).disabled && !option.disabled)) {
                    option.selected = false;
                    this.dispatchEvent(new Event("change"));
                }
            });
        });
    }

    public disableOptions(options: Array<string | number>): boolean {
        let fireDataChanged: boolean = false;
        if (this.data.every(el => options.includes(el))) {
            this.data = [];
            //Lanzar evento pq se borra el seleccionado
            fireDataChanged = true;
        }
        this.enableDisableOptions(options, true);
        return fireDataChanged;
    }

}

export function initSelectMultipleInputWebComponent() {
    window.customElements.define("s6-select-multiple-input", SelectMultipleInputElement);
}
